var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11315 8.86003C4.35901 9.10829 4.6427 9.23242 4.96421 9.23242C5.28573 9.23242 5.56941 9.10829 5.81528 8.86003C6.06114 8.61176 6.18407 8.3253 6.18407 8.00065C6.18407 7.676 6.06114 7.38954 5.81528 7.14128C5.56941 6.89301 5.28573 6.76888 4.96421 6.76888C4.6427 6.76888 4.35901 6.89301 4.11315 7.14128C3.8862 7.38954 3.77272 7.676 3.77272 8.00065C3.77272 8.3253 3.8862 8.61176 4.11315 8.86003ZM8.39684 6.76888H14.6663V9.23242H13.4465V11.6673H11.0351V9.23242H8.39684C8.15097 9.90082 7.68762 10.4737 7.00677 10.9512C6.34483 11.4286 5.66398 11.6673 4.96421 11.6673C3.96185 11.6673 3.10133 11.314 2.38265 10.6074C1.68289 9.88173 1.33301 9.0128 1.33301 8.00065C1.33301 6.9885 1.68289 6.12912 2.38265 5.42253C3.10133 4.69683 3.96185 4.33398 4.96421 4.33398C5.66398 4.33398 6.34483 4.5727 7.00677 5.05013C7.68762 5.52756 8.15097 6.10048 8.39684 6.76888Z",
    fill: "#09090A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon-password.e153f4c73bcaea959cbd3297aa8c579c.svg";
export { ForwardRef as ReactComponent };